<div class="modal-header">
  <h4 class="modal-title">
    <i class="fas fa-gift"></i>
    Descuentos por volumen
  </h4>
  <button
    type="button"
    class="btn-close-modal"
    aria-label="Close"
    (click)="onClosemodal()"
  >
    <i class="fas fa-times"></i>
  </button>
</div>

<div class="modal-body-custom">
  <!-- Grid de descuentos compacto -->
  <div class="discounts-grid">
    <!-- Descuento 1 -->
    <div class="discount-item no-discount">
      <div class="discount-qty">
        1-4
        <p style="font-size: small; font-family: emoji; color: darkgreen">
          imágenes
        </p>
      </div>
      <div class="discount-empty-space"></div>
      <div class="discount-label">Sin descuento</div>
    </div>

    <!-- Descuento 2 - Popular -->
    <div class="discount-item popular">
      <div class="discount-badge">
        <i class="fas fa-star"></i>
        Popular
      </div>
      <div class="discount-qty">
        5
        <p style="font-size: small; font-family: emoji; color: darkgreen">
          imágenes
        </p>
      </div>
      <div class="discount-percent">-20%</div>
      <div class="discount-label">Pagas solo 4</div>
    </div>

    <!-- Descuento 3 -->
    <div class="discount-item">
      <div class="discount-qty">
        6-24
        <p style="font-size: small; font-family: emoji; color: darkgreen">
          imágenes
        </p>
      </div>
      <div class="discount-percent">-20%</div>
      <div class="discount-label">Ahorro garantizado</div>
    </div>

    <!-- Descuento 4 - Mejor -->
    <div class="discount-item best">
      <div class="discount-badge best-badge">
        <i class="fas fa-crown"></i>
        Mejor
      </div>
      <div class="discount-qty">
        25+
        <p style="font-size: small; font-family: emoji; color: darkgreen">
          imágenes
        </p>
      </div>
      <div class="discount-label-split">
        <span class="split-line">20% + 10%</span>
      </div>
      <div class="discount-label split-subtitle">adicional</div>
    </div>
  </div>

  <!-- Nota compacta -->
  <div class="note-compact">
    <i class="fas fa-info-circle"></i>
    Descuentos automáticos por modalidad
  </div>

  <!-- Checkbox y botones juntos -->
  <div class="footer-section">
    <div class="form-check">
      <input
        class="form-check-input"
        type="checkbox"
        id="noShowAgain"
        [(ngModel)]="noShowAgain"
      />
      <label class="form-check-label" for="noShowAgain">
        No mostrar de nuevo
      </label>
    </div>

    <div class="actions-compact">
      <button class="btn-explore" (click)="irAExplorarFotos()">VER FOTOS</button>
      <button class="btn-explore" (click)="irAExplorarPortadas()">VER PORTADAS</button>
      <button class="btn-close-compact" (click)="cerrarModal()">Cerrar</button>
    </div>
  </div>
</div>
